{
  "cards": {
    "title": "Sincronizar datos",
    "description": "Trae los cambios de tu sistema en este orden: sedes, trabajadores, horarios y ausencias.",
    "sync": "Sincronizar",
    "full": "Sincronización completa",
    "fullTitle": "¿Hacer una sincronización completa?",
    "fullDescription": "Leerá todos los registros de {resource}, no solo los cambios. Puede tardar.",
    "fullConfirm": "Sincronizar todo",
    "notOffered": "Tu sistema no ofrece este dato.",
    "neverSynced": "Aún no se ha sincronizado.",
    "lastRun": "Última: {status} · {date}",
    "summary": {
      "created": "{count} creados",
      "updated": "{count} actualizados",
      "deactivated": "{count} desactivados",
      "needs_review": "{count} para revisión",
      "error": "{count} con error"
    },
    "noChanges": "Sin cambios",
    "viewDetail": "Ver detalle",
    "reviewPreview": "Revisar vista previa",
    "awaiting": "Vista previa lista para revisar",
    "sitesFirst": "Sincroniza primero las sedes.",
    "schedulesUntil": "Horarios integrados hasta {date}",
    "firstPreview": "La primera vez verás una vista previa antes de aplicar nada.",
    "blocked": {
      "notVerified": "Prueba la conexión antes de sincronizar.",
      "disabled": "La conexión está desactivada.",
      "syncDisabled": "En este servidor no se puede sincronizar."
    },
    "alreadyRunning": "Ya había una sincronización de {resource} en curso: te mostramos esa.",
    "started": "Sincronización de {resource} iniciada"
  },
  "progress": {
    "queued": "En cola…",
    "reading": "Leyendo página {pages} · {records} registros",
    "applying": "Aplicando los cambios…",
    "starting": "Conectando con tu sistema…",
    "label": "Progreso de la sincronización"
  },
  "preview": {
    "loadFailed": "No pudimos cargar la vista previa",
    "loadMore": "Cargar más"
  },
  "sitePreview": {
    "title": "Sedes de tu sistema",
    "description": "Revisa qué pasará con cada sede. Puedes cambiar la propuesta antes de confirmar.",
    "empty": "No hay sedes para revisar.",
    "columns": {
      "site": "Sede externa",
      "timezone": "Zona",
      "location": "Ubicación",
      "proposal": "Propuesta",
      "action": "Qué hacer"
    },
    "noTimezone": "Zona de la empresa",
    "noLocation": "Sin ubicación",
    "inactive": "Inactiva en el origen",
    "deleted": "Borrada en el origen",
    "matches": "Coincide con {site}",
    "actions": {
      "LINK": "Vincular con…",
      "CREATE": "Crear",
      "SKIP": "Omitir"
    },
    "actionLabel": "Qué hacer con {site}",
    "linkPlaceholder": "Elige una sede",
    "linkSearch": "Buscar sede",
    "linkEmpty": "No hay sedes libres con ese nombre",
    "linkLabel": "Sede de Fermin para {site}",
    "linkMissing": "Elige una sede; si no, se aplicará la propuesta.",
    "latitude": "Latitud",
    "longitude": "Longitud",
    "zone": "Zona horaria",
    "zonePlaceholder": "America/Lima",
    "radius": "Radio (m)",
    "pendingLocation": "Quedará pendiente de ubicación.",
    "invalidLatitude": "Entre −90 y 90",
    "invalidLongitude": "Entre −180 y 180",
    "invalidRadius": "Entre 20 y 2000",
    "incompleteLocation": "Ingresa latitud y longitud.",
    "readOnly": "Sin opciones",
    "onlyInFerminTitle": "Solo en Fermin",
    "onlyInFerminDescription": "Estas sedes no están en tu sistema: se quedan como están, gestionadas en Fermin.",
    "changed": "{count} cambios respecto a la propuesta"
  }
}
